<template>
    <header class="services-modal-sk-header sk-header">
        <div class="sk-header__info">
            <div class="sk-header__icon">
                <img
                    v-if="icon"
                    :src="icon"
                    :alt="name"
                >
            </div>
            <div class="sk-header__desc">
                <div class="sk-header__title">
                    {{name}}
                </div>
                <div 
                    v-if="isShowSubtitle"
                    class="sk-header__subtitle"
                >
                    {{$t('ui.list-below')}}
                </div>
            </div>
        </div>
        <div 
            class="sk-header__close"
            @click="closeModal"
        >
            {{$t('ui.close')}}

            <svg-icon
                original
                name="icons/close-pink"
            />
        </div>
    </header>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "OServicesModalSKHeader",
    props: {
        service: {
            type: Object,
            default: () => ({})
        },
        isShowSubtitle: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters([
            't'
        ]),
        icon() {
            return this.t(this.service, 'icon') || '';
        },
        name() {
            return this.t(this.service, 'name') || '';
        },
    },
    methods: {
        closeModal() {
            this.$emit('closeModal')
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>
